"use client";

import { MoveRight } from "lucide-react";
import Link from "next/link";

export default function CircleArrow({className, href, ...props}){
    const Component = href ? Link : 'button';
    
    return (
        <Component 
          {...(href && { href })}
          className={` ${className } z-40 h-[52px] w-[52px] rounded-full border border-white/20 flex items-center justify-center transition-all active:border-2 active:border-white hover:bg-white/10 group`}
          {...props}
        >
          <MoveRight className="text-white opacity-50 group-hover:opacity-100" size={24} />
        </Component>
    )
}